<template>
  <div class="index-banner">
    <el-carousel :autoplay="false" v-if="list.length">
      <el-carousel-item v-for="item in list" :key="item.id">
        <div class="banner-img">
          <img :src="item.imgUrl" :alt="item.imgUrl" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { localStore } from '@/utils/store'
import * as ConstantRouter from '@/constant/router'

export default {
  props: ['activeNav'],
  data() {
    return {
      jsId: this.$route.params.jsId,
      list: [],
      lang: localStore.get('lang') || 'cn' // 语言标识
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    toIndex() {
      this.$router.push({
        name: ConstantRouter.EVENT
      })
    },
    changeLang(lang) {
      localStore.set('lang', lang)
      location.reload()
    },
    async fetchList() {
      const [err, res] = await this.$serve.jsBanner.getPageList({
        data: {
          pageIndex: 1,
          pageSize: 10,
          jsId: this.jsId
        }
      })
      if (err) return
      this.list = res.records
    },
    toCollections() {
      this.$router.push({
        name: ConstantRouter.COLLECTIONS
      })
    },
    toExperts() {
      this.$router.push({
        name: ConstantRouter.EXPERTS
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.index-banner {
  position: relative;

  .banner-img {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
::v-deep {
  .el-carousel__container {
    height: 650px;
  }
  .el-dropdown-selfdefine {
    color: #fff;
  }
}

@media (max-width: 1199px) {
  ::v-deep {
    .el-carousel__container {
      height: 400px;
    }
  }
}
</style>
